(function(){
  /* ===== Scroll Reveal ===== */
  function kpInitReveal(){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('is-visible');
          var children=e.target.querySelectorAll('.kp-fade-child');
          var i=0;
          children.forEach(function(c){
            setTimeout(function(){c.classList.add('is-visible');},i*90);
            i++;
          });
        }
      });
    },{threshold:0.1});
    document.querySelectorAll('.kp-fade-up').forEach(function(el){obs.observe(el);});
  }

  /* ===== FAQ Accordion ===== */
  function kpInitFAQ(){
    document.querySelectorAll('.kp-faq-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        var item=this.closest('.kp-faq-item');
        var content=item.querySelector('.kp-faq-content');
        var iconWrap=this.querySelector('.kp-faq-icon-wrap');
        var isOpen=item.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.kp-faq-item').forEach(function(fi){
          fi.classList.remove('is-open');
          fi.querySelector('.kp-faq-content').style.maxHeight='0';
          var iw=fi.querySelector('.kp-faq-icon-wrap');
          if(iw){iw.style.background='rgba(45,95,63,0.10)';iw.innerHTML='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2D5F3F" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg>';}
        });
        if(!isOpen){
          item.classList.add('is-open');
          content.style.maxHeight=content.scrollHeight+'px';
          if(iconWrap){iconWrap.style.background='#2D5F3F';iconWrap.innerHTML='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFF" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>';}
        }
      });
    });
    // Open first by default
    var first=document.querySelector('.kp-faq-item');
    if(first){
      first.classList.add('is-open');
      var fc=first.querySelector('.kp-faq-content');
      if(fc)fc.style.maxHeight=fc.scrollHeight+'px';
      var iw=first.querySelector('.kp-faq-icon-wrap');
      if(iw){iw.style.background='#2D5F3F';iw.innerHTML='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFF" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>';}
    }
  }

  /* ===== Sticky Mobile Bar ===== */
  function kpInitSticky(){
    var bar=document.querySelector('.kp-sticky-bar');
    if(!bar)return;
    window.addEventListener('scroll',function(){
      if(window.scrollY>500){bar.classList.add('is-visible');}
      else{bar.classList.remove('is-visible');}
    },{passive:true});
  }

  /* ===== Add to Cart ===== */
  window.kpAddToCart=function(){
    var btn=document.querySelector('button[name="add"],.product-form__submit,#AddToCart,[data-testid="add-to-cart"]');
    if(btn){btn.click();return;}
    var form=document.querySelector('form[action="/cart/add"],form.product-form');
    if(form)form.submit();
  };

  function kpInitAll(){kpInitReveal();kpInitFAQ();kpInitSticky();}
  document.addEventListener('DOMContentLoaded',kpInitAll);
  document.addEventListener('shopify:section:load',kpInitAll);
})();
